// =============================================================================
// Ring-chart palette — v2 design system.
//
// Mellow Tailwind-300 pastels for share-of-metric donut slices (Creatives,
// Publishers, Segments, Basket Items, Transactions). Replaces the saturated
// rainbow at `src/admin/core/utils/constants/listOfColors.js:11-25` whose
// first dozen entries — `#9b59b6`, `#00caff`, `#2ac86f`, `#f1c40f`,
// `#f39c12`, `#e74c3c` … — read as harsh against the v2 card chrome.
//
// Hue order is intentional: cool → warm → cool, so adjacent slices stay
// distinguishable when the chart has many entries. The first 12 cycle if
// `index >= ringPalette.length`; consumers can still use `palette[index]`
// directly because indices wrap via the helper.
//
// Reserved fallback: `RING_OTHER_COLOR` is the slate-300 grey used by
// `BreakdownRingChart`'s "Other (N)" aggregation bucket.
// =============================================================================

export const ringPalette = [
  '#93c5fd', // blue-300
  '#6ee7b7', // emerald-300
  '#fcd34d', // amber-300
  '#fda4af', // rose-300
  '#c4b5fd', // violet-300
  '#67e8f9', // cyan-300
  '#fdba74', // orange-300
  '#f9a8d4', // pink-300
  '#bef264', // lime-300
  '#7dd3fc', // sky-300
  '#a5b4fc', // indigo-300
  '#d8b4fe', // purple-300
  // Cycle through a slightly different sweep for indices 12-23 so a long
  // entity list still feels differentiated rather than a hard repeat.
  '#86efac', // green-300
  '#fde047', // yellow-300
  '#5eead4', // teal-300
  '#f0abfc', // fuchsia-300
  '#fca5a5', // red-300
  '#a7f3d0', // emerald-200
  '#bae6fd', // sky-200
  '#fed7aa', // orange-200
  '#ddd6fe', // violet-200
  '#fecaca', // red-200
  '#bbf7d0', // green-200
  '#c7d2fe', // indigo-200
];

export const RING_OTHER_COLOR = '#cbd5e1'; // slate-300

// Index-safe accessor that cycles through the palette so consumers never get
// `undefined` for very long lists. Keep this in sync with the BreakdownRingChart
// "Other" bucket policy in `BreakdownRingChart.js`.
export const getRingColor = (index) => ringPalette[index % ringPalette.length];
